// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSolarPanel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.901 4.608h16.16l2.29 11.506H1.652zM8.06 16.11 9.24 4.609M14.66 4.608l1.18 11.503M3.552 8.16h16.872M2.667 11.959h18.641M11.986 16.114v3.11M14.969 19.392H8.996"
    />
  </svg>
);
export default SvgSolarPanel;
